var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      ref: "menu",
      attrs: {
        "offset-y": "",
        "nudge-bottom": 16,
        left: _vm.openLeft,
        "close-on-content-click": false,
        "z-index": 99999,
        transition: "fade-transition",
        "min-width": "300",
        "max-width": "340",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "button",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "column-menu-btn",
                      class: {
                        "is-active": _vm.value != null,
                        "is-open": _vm.open,
                      },
                      attrs: {
                        type: "button",
                        title:
                          (_vm.sortable
                            ? "Sort and filter by "
                            : "Filter by ") + _vm.label,
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.pickSide.apply(null, arguments)
                        },
                      },
                    },
                    "button",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        small: "",
                        color: _vm.value != null ? _vm.color : undefined,
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.value != null
                              ? _vm.$MDI.Filter
                              : _vm.$MDI.FilterOutline
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        [
          _vm.sortable
            ? _c(
                "v-list",
                { staticClass: "py-0", attrs: { dense: "" } },
                [
                  _c(
                    "v-list-item",
                    {
                      staticStyle: { padding: "0 12px" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("sort")
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "margin-right": "12px",
                          },
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v(_vm._s(_vm.$MDI.Sort)),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v("Sort by " + _vm._s(_vm.label)),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-action",
                        { staticClass: "my-0" },
                        [
                          _c(
                            "v-icon",
                            {
                              style: { opacity: _vm.sortSelected ? 1 : 0.4 },
                              attrs: {
                                color: _vm.sortSelected ? _vm.color : undefined,
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.sortIcon) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.sortable ? _c("v-divider") : _vm._e(),
          _vm._v(" "),
          _c("ResultFilterField", {
            ref: "field",
            staticClass: "pa-3",
            attrs: {
              label: _vm.label,
              kind: _vm.kind,
              value: _vm.value,
              color: _vm.color,
              bounds: _vm.bounds,
              logScale: _vm.logScale,
              integer: _vm.integer,
              taxOptions: _vm.taxOptions,
              choices: _vm.choices,
            },
            on: { filter: (v) => _vm.$emit("filter", v) },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }